export const challenges = {
  appBarTitle: "التحديات",
  addChallenge: "إضافة تحدي",
  noChallenges: "لا توجد تحديات بعد",
  challengesPerPage: "التحديات في الصفحة",

  tabs: {
    ongoing: "جارية",
    pending: "قادمة",
    ended: "منتهية",
  },

  status: {
    pending: "قيد الانتظار",
    started: "جارٍ",
    ended: "منتهى",
    draft: "مسودة",
  },

  type: {
    promo: "تحدي ترويجي",
    quick: "تحدي سريع",
  },

  targetPersonas: {
    fo: "صاحب أسطول",
    so: "سائق حر",
    driver: "سائق في أسطول",
  },

  rewardTypes: {
    air_recharge: "شحن رصيد",
  },

  userStatus: {
    inProgress: "جارٍ",
    urgent: "عاجل",
    awaitingReview: "في انتظار المراجعة",
    outOfCap: "خارج الحد",
    won: "فائز",
    notQualified: "غير مؤهل",
  },

  rewardStatus: {
    pendingSelection: "في انتظار الاختيار",
    selected: "تم الاختيار",
    redeemed: "تم الاسترداد",
    expiredNotSelected: "منتهي — لم يُختَر",
    expiredNotRedeemed: "منتهي — لم يُسترَد",
    failedAdminReview: "فشل — مراجعة المشرف",
  },

  winnerStatus: {
    winner: "فائز",
    nonWinner: "غير فائز",
    notQualified: "غير مؤهل",
  },

  card: {
    view: "عرض",
    edit: "تعديل",
    duplicate: "تكرار",
    deleteDraft: "حذف المسودة",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    published: "تم النشر",
    unpublished: "غير منشور",
    starts: "يبدأ",
    ends: "ينتهي",
    winner: "فائز",
    winners: "فائز",
    currency: "جنيه",
    reward: "المكافأة",
    cap: "الحد الأقصى",
    rewardSubmitted: "تم التسليم",
  },

  publishChallenge: "نشر التحدي",
  publishConfirm:
    "سيؤدي النشر إلى إتاحة هذا التحدي للمستخدمين المؤهلين. هل أنت متأكد؟",
  unpublishChallenge: "إلغاء نشر التحدي",
  unpublishConfirm:
    "سيؤدي إلغاء النشر إلى إخفاء التحدي عن المستخدمين مع الحفاظ على التقدم الجاري. هل أنت متأكد؟",
  duplicateChallenge: "تكرار التحدي",
  duplicateConfirm: "سيُنشئ هذا نسخة مسودة من التحدي. هل أنت متأكد؟",
  deleteDraft: "حذف المسودة",
  deleteDraftConfirm: "سيؤدي هذا إلى حذف المسودة نهائيًا. هل أنت متأكد؟",
  editBlockedEnded: "لا يمكن تعديل التحديات المنتهية.",

  challengeForm: {
    createTitle: "إضافة تحدي",
    editTitle: "تعديل التحدي",
    duplicateTitle: "تكرار التحدي",
    create: "إنشاء التحدي",
    edit: "تعديل",
    duplicate: "إنشاء النسخة",
    saveAsDraft: "حفظ كمسودة",
    challengeType: "نوع التحدي",
    duration: "المدة والاستهداف",
    bannerAssets: "صور البانر",
    content: "محتوى التحدي",
    rewardConfig: "إعداد المكافأة",
    subTasks: "المهام الفرعية",
    notificationCopy: "الإشعارات",
    notificationTypes: {
      start_quick_challenge: "النشر",
      mid_quick_challenge: "تذكير منتصف المدة",
      last_day_quick_challenge: "تذكير اليوم الأخير",
      winner: "الفائزون",
      non_winner: "غير الفائزين",
    },
    challengeName: "اسم التحدي",
    targetPersona: "الفئة المستهدفة",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    homeBanner: "بانر الرئيسية",
    popupBanner: "بانر النافذة المنبثقة",
    homeBannerRatio: "(8:3)",
    popupBannerRatio: "(4:3)",
    requiresMobilawy: "يتطلب محفظة موبيلاوي",
    internalNameEn: "الاسم الداخلي بالإنجليزية",
    internalNameAr: "الاسم الداخلي بالعربية",
    quickChallengeTitleEn: "عنوان التحدي السريع بالإنجليزية",
    quickChallengeTitleAr: "عنوان التحدي السريع بالعربية",
    promotionTitleEn: "عنوان التحدي السريع بالإنجليزية",
    promotionTitleAr: "عنوان التحدي السريع بالعربية",
    promotionNameEn: "اسم العرض بالإنجليزية",
    promotionNameAr: "اسم العرض بالعربية",
    rewardPhoto: "صورة المكافأة",
    rewardType: "نوع المكافأة",
    rewardValue: "قيمة المكافأة (جنيه)",
    numberOfWinners: "عدد الفائزين",
    displayLabelEn: "تسمية العرض بالإنجليزية",
    displayLabelAr: "تسمية العرض بالعربية",
    configureReward: "إعداد المكافأة",
    editReward: "تعديل المكافأة",
    noRewardConfigured: "لم يتم إعداد مكافأة",
    subTasksNoPersona: "اختر فئة مستهدفة واحدة على الأقل لإعداد المهام الفرعية.",
    subTask: "مهمة فرعية",
    noSubTasksYet: "لم يتم إضافة مهام فرعية بعد.",
    addSubTask: "إضافة مهمة فرعية",
    subTaskNameEn: "اسم المهمة الفرعية بالإنجليزية",
    subTaskNameAr: "اسم المهمة الفرعية بالعربية",
    signalType: "نوع الإشارة",
    targetValue: "القيمة المستهدفة",
    withinDuration: "خلال مدة التحدي",
    shortDescEn: "وصف مختصر بالإنجليزية",
    shortDescAr: "وصف مختصر بالعربية",
    howToWinEn: "طريقة الفوز بالإنجليزية",
    howToWinAr: "طريقة الفوز بالعربية",
    ctaCopyEn: "CTA بالإنجليزية",
    ctaCopyAr: "CTA بالعربية",
    endDateInfoEn: "معلومات تاريخ الانتهاء بالإنجليزية",
    endDateInfoAr: "معلومات تاريخ الانتهاء بالعربية",
    howToWinTitleEn: "عنوان طريقة الفوز بالإنجليزية",
    howToWinTitleAr: "عنوان طريقة الفوز بالعربية",
    detailInfo: "معلومات تفصيلية",
    howToWinInfoEn: "تفاصيل طريقة الفوز بالإنجليزية",
    howToWinInfoAr: "تفاصيل طريقة الفوز بالعربية",
    rewardInfoEn: "معلومات المكافأة بالإنجليزية",
    rewardInfoAr: "معلومات المكافأة بالعربية",
    tcInfoEn: "الشروط والأحكام بالإنجليزية",
    tcInfoAr: "الشروط والأحكام بالعربية",
    publishingNotifTitleEn: "العنوان بالإنجليزية",
    publishingNotifTitleAr: "العنوان بالعربية",
    publishingNotifBodyEn: "النص بالإنجليزية",
    publishingNotifBodyAr: "النص بالعربية",
    reminderNotifTitleEn: "العنوان بالإنجليزية",
    reminderNotifTitleAr: "العنوان بالعربية",
    reminderNotifBodyEn: "النص بالإنجليزية",
    reminderNotifBodyAr: "النص بالعربية",
    lastDayNotifTitleEn: "العنوان بالإنجليزية",
    lastDayNotifTitleAr: "العنوان بالعربية",
    lastDayNotifBodyEn: "النص بالإنجليزية",
    lastDayNotifBodyAr: "النص بالعربية",
    winnersNotifTitleEn: "العنوان بالإنجليزية",
    winnersNotifTitleAr: "العنوان بالعربية",
    winnersNotifBodyEn: "النص بالإنجليزية",
    winnersNotifBodyAr: "النص بالعربية",
    nonWinnersNotifTitleEn: "العنوان بالإنجليزية",
    nonWinnersNotifTitleAr: "العنوان بالعربية",
    nonWinnersNotifBodyEn: "النص بالإنجليزية",
    nonWinnersNotifBodyAr: "النص بالعربية",
    confirm: "تأكيد",
    cancel: "إلغاء",
    personaSwitchConfirm: "إزالة",
    personaSwitchTitle: "إزالة الفئة؟",
    personaSwitchDescription: "هذه الفئة تحتوي على مهام فرعية بها بيانات مُدخَلة. إزالتها سيؤدي إلى فقدان تلك البيانات. هل تريد المتابعة؟",

    // Persona labels
    personas: {
      fo: "مالك أسطول",
      so: "مالك فردي",
      driver: "سائق",
    },

    // Signal types labels
    signalTypes: {
      kyc: "التحقق من الهوية",
      referral: "الإحالة",
      addVehicle: "إضافة مركبة",
      addDriver: "إضافة سائق",
      addMaintenance: "إضافة مصروف",
      coveredKm: "الكيلومترات المقطوعة",
      joinFleet: "الانضمام إلى أسطول",
      level: "المستوى",
    },

    // Validation messages
    validation: {
      promotionTitleEnReq: "عنوان التحدي السريع بالإنجليزية مطلوب",
      promotionTitleEnValid: "عنوان التحدي السريع بالإنجليزية يحتوي على أحرف غير صالحة",
      promotionTitleEnMax:
        "عنوان التحدي السريع بالإنجليزية يجب أن يكون 30 حرفًا أو أقل",
      promotionTitleArReq: "عنوان التحدي السريع بالعربية مطلوب",
      promotionTitleArValid: "عنوان التحدي السريع بالعربية يحتوي على أحرف غير صالحة",
      promotionTitleArMax: "عنوان التحدي السريع بالعربية يجب أن يكون 30 حرفًا أو أقل",
      startDateReq: "تاريخ البداية مطلوب",
      startDateValid: "تاريخ البداية يجب أن يكون تاريخًا صالحًا",
      startDateMin: "تاريخ البداية يجب أن يكون تاريخًا مستقبليًا (بعد اليوم)",
      endDateReq: "تاريخ النهاية مطلوب",
      endDateValid: "تاريخ النهاية يجب أن يكون تاريخًا صالحًا",
      endDateMin: "تاريخ النهاية يجب أن يكون في أو بعد تاريخ البداية",
      targetPersonasReq: "اختر فئة مستهدفة واحدة على الأقل",
      numberOfWinnersReq: "عدد الفائزين مطلوب",
      numberOfWinnersPositive: "عدد الفائزين يجب أن يكون رقمًا موجبًا",
      numberOfWinnersInteger: "عدد الفائزين يجب أن يكون رقمًا صحيحًا",
      numberOfWinnersTypeError: "عدد الفائزين يجب أن يحتوي على أرقام فقط",
      numberOfWinnersMax: "عدد الفائزين يجب أن يكون 9999 أو أقل",
      numberOfWinnersCapDecrease:
        "لا يمكن تقليل عدد الفائزين بعد بدء التحدي، يمكن زيادته فقط",
      howToWinEnReq: "نص طريقة الفوز بالإنجليزية مطلوب",
      howToWinEnValid: "نص طريقة الفوز بالإنجليزية يحتوي على أحرف غير صالحة",
      howToWinEnMax: "نص طريقة الفوز بالإنجليزية يجب أن يكون 150 حرف أو أقل",
      howToWinArReq: "نص طريقة الفوز بالعربية مطلوب",
      howToWinArValid: "نص طريقة الفوز بالعربية يحتوي على أحرف غير صالحة",
      howToWinArMax: "نص طريقة الفوز بالعربية يجب أن يكون 150 حرف أو أقل",
      shortDescEnReq: "الوصف المختصر بالإنجليزية مطلوب",
      shortDescEnValid: "الوصف المختصر بالإنجليزية يحتوي على أحرف غير صالحة",
      shortDescEnMax: "الوصف المختصر بالإنجليزية يجب أن يكون 80 حرف أو أقل",
      shortDescArReq: "الوصف المختصر بالعربية مطلوب",
      shortDescArValid: "الوصف المختصر بالعربية يحتوي على أحرف غير صالحة",
      shortDescArMax: "الوصف المختصر بالعربية يجب أن يكون 80 حرف أو أقل",
      ctaCopyEnReq: "نص الزر بالإنجليزية مطلوب",
      ctaCopyEnValid: "نص الزر بالإنجليزية يحتوي على أحرف غير صالحة",
      ctaCopyEnMax: "نص الزر بالإنجليزية يجب أن يكون 25 حرف أو أقل",
      ctaCopyArReq: "نص الزر بالعربية مطلوب",
      ctaCopyArValid: "نص الزر بالعربية يحتوي على أحرف غير صالحة",
      ctaCopyArMax: "نص الزر بالعربية يجب أن يكون 25 حرف أو أقل",
      rewardReq: "إعداد المكافأة مطلوب",
      rewardTypeReq: "نوع المكافأة مطلوب",
      rewardStatusReq: "حالة المكافأة مطلوبة",
      requiredPointsReq: "النقاط المطلوبة مطلوبة",
      requiredPointsPositive: "يجب أن تكون النقاط المطلوبة أكبر من 0",
      rewardValueReq: "قيمة المكافأة مطلوبة",
      rewardValuePositive: "قيمة المكافأة يجب أن تكون رقمًا موجبًا",
      displayLabelEnReq: "تسمية العرض بالإنجليزية مطلوبة",
      displayLabelEnMax: "تسمية العرض بالإنجليزية يجب أن تكون 100 حرف أو أقل",
      displayLabelArReq: "تسمية العرض بالعربية مطلوبة",
      displayLabelArMax: "تسمية العرض بالعربية يجب أن تكون 100 حرف أو أقل",
      subTasksMin: "أضف مهمة فرعية واحدة على الأقل",
      subTasksMax: "الحد الأقصى 3 مهام فرعية",
      subTasksFieldsInvalid: "جميع حقول المهمة الفرعية (الاسم، نوع الإشارة، القيمة المستهدفة) مطلوبة",
      publishingNotifTitleEnReq: "عنوان إشعار النشر باللغة الإنجليزية مطلوب",
      publishingNotifTitleEnValid: "عنوان إشعار النشر باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      publishingNotifTitleArReq: "عنوان إشعار النشر باللغة العربية مطلوب",
      publishingNotifTitleArValid: "عنوان إشعار النشر باللغة العربية يحتوي على أحرف غير صالحة",
      publishingNotifBodyEnReq: "نص إشعار النشر باللغة الإنجليزية مطلوب",
      publishingNotifBodyEnValid: "نص إشعار النشر باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      publishingNotifBodyArReq: "نص إشعار النشر باللغة العربية مطلوب",
      publishingNotifBodyArValid: "نص إشعار النشر باللغة العربية يحتوي على أحرف غير صالحة",
      reminderNotifTitleEnReq: "عنوان إشعار التذكير باللغة الإنجليزية مطلوب",
      reminderNotifTitleEnValid: "عنوان إشعار التذكير باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      reminderNotifTitleArReq: "عنوان إشعار التذكير باللغة العربية مطلوب",
      reminderNotifTitleArValid: "عنوان إشعار التذكير باللغة العربية يحتوي على أحرف غير صالحة",
      reminderNotifBodyEnReq: "نص إشعار التذكير باللغة الإنجليزية مطلوب",
      reminderNotifBodyEnValid: "نص إشعار التذكير باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      reminderNotifBodyArReq: "نص إشعار التذكير باللغة العربية مطلوب",
      reminderNotifBodyArValid: "نص إشعار التذكير باللغة العربية يحتوي على أحرف غير صالحة",
      lastDayNotifTitleEnReq: "عنوان إشعار اليوم الأخير باللغة الإنجليزية مطلوب",
      lastDayNotifTitleEnValid: "عنوان إشعار اليوم الأخير باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      lastDayNotifTitleArReq: "عنوان إشعار اليوم الأخير باللغة العربية مطلوب",
      lastDayNotifTitleArValid: "عنوان إشعار اليوم الأخير باللغة العربية يحتوي على أحرف غير صالحة",
      lastDayNotifBodyEnReq: "نص إشعار اليوم الأخير باللغة الإنجليزية مطلوب",
      lastDayNotifBodyEnValid: "نص إشعار اليوم الأخير باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      lastDayNotifBodyArReq: "نص إشعار اليوم الأخير باللغة العربية مطلوب",
      lastDayNotifBodyArValid: "نص إشعار اليوم الأخير باللغة العربية يحتوي على أحرف غير صالحة",
      winnersNotifTitleEnReq: "عنوان إشعار الفائزين باللغة الإنجليزية مطلوب",
      winnersNotifTitleEnValid: "عنوان إشعار الفائزين باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      winnersNotifTitleArReq: "عنوان إشعار الفائزين باللغة العربية مطلوب",
      winnersNotifTitleArValid: "عنوان إشعار الفائزين باللغة العربية يحتوي على أحرف غير صالحة",
      winnersNotifBodyEnReq: "نص إشعار الفائزين باللغة الإنجليزية مطلوب",
      winnersNotifBodyEnValid: "نص إشعار الفائزين باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      winnersNotifBodyArReq: "نص إشعار الفائزين باللغة العربية مطلوب",
      winnersNotifBodyArValid: "نص إشعار الفائزين باللغة العربية يحتوي على أحرف غير صالحة",
      nonWinnersNotifTitleEnReq: "عنوان إشعار غير الفائزين باللغة الإنجليزية مطلوب",
      nonWinnersNotifTitleEnValid: "عنوان إشعار غير الفائزين باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      nonWinnersNotifTitleArReq: "عنوان إشعار غير الفائزين باللغة العربية مطلوب",
      nonWinnersNotifTitleArValid: "عنوان إشعار غير الفائزين باللغة العربية يحتوي على أحرف غير صالحة",
      nonWinnersNotifBodyEnReq: "نص إشعار غير الفائزين باللغة الإنجليزية مطلوب",
      nonWinnersNotifBodyEnValid: "نص إشعار غير الفائزين باللغة الإنجليزية يحتوي على أحرف غير صالحة",
      nonWinnersNotifBodyArReq: "نص إشعار غير الفائزين باللغة العربية مطلوب",
      nonWinnersNotifBodyArValid: "نص إشعار غير الفائزين باللغة العربية يحتوي على أحرف غير صالحة",
      publishingNotifTitleEnMax: "عنوان إشعار النشر باللغة الإنجليزية يجب أن يكون 50 حرف أو أقل",
      publishingNotifTitleArMax: "عنوان إشعار النشر باللغة العربية يجب أن يكون 50 حرف أو أقل",
      publishingNotifBodyEnMax: "نص إشعار النشر باللغة الإنجليزية يجب أن يكون 250 حرف أو أقل",
      publishingNotifBodyArMax: "نص إشعار النشر باللغة العربية يجب أن يكون 250 حرف أو أقل",
      reminderNotifTitleEnMax: "عنوان إشعار التذكير باللغة الإنجليزية يجب أن يكون 50 حرف أو أقل",
      reminderNotifTitleArMax: "عنوان إشعار التذكير باللغة العربية يجب أن يكون 50 حرف أو أقل",
      reminderNotifBodyEnMax: "نص إشعار التذكير باللغة الإنجليزية يجب أن يكون 250 حرف أو أقل",
      reminderNotifBodyArMax: "نص إشعار التذكير باللغة العربية يجب أن يكون 250 حرف أو أقل",
      lastDayNotifTitleEnMax: "عنوان إشعار اليوم الأخير باللغة الإنجليزية يجب أن يكون 50 حرف أو أقل",
      lastDayNotifTitleArMax: "عنوان إشعار اليوم الأخير باللغة العربية يجب أن يكون 50 حرف أو أقل",
      lastDayNotifBodyEnMax: "نص إشعار اليوم الأخير باللغة الإنجليزية يجب أن يكون 250 حرف أو أقل",
      lastDayNotifBodyArMax: "نص إشعار اليوم الأخير باللغة العربية يجب أن يكون 250 حرف أو أقل",
      winnersNotifTitleEnMax: "عنوان إشعار الفائزين باللغة الإنجليزية يجب أن يكون 50 حرف أو أقل",
      winnersNotifTitleArMax: "عنوان إشعار الفائزين باللغة العربية يجب أن يكون 50 حرف أو أقل",
      winnersNotifBodyEnMax: "نص إشعار الفائزين باللغة الإنجليزية يجب أن يكون 250 حرف أو أقل",
      winnersNotifBodyArMax: "نص إشعار الفائزين باللغة العربية يجب أن يكون 250 حرف أو أقل",
      nonWinnersNotifTitleEnMax: "عنوان إشعار غير الفائزين باللغة الإنجليزية يجب أن يكون 50 حرف أو أقل",
      nonWinnersNotifTitleArMax: "عنوان إشعار غير الفائزين باللغة العربية يجب أن يكون 50 حرف أو أقل",
      nonWinnersNotifBodyEnMax: "نص إشعار غير الفائزين باللغة الإنجليزية يجب أن يكون 250 حرف أو أقل",
      nonWinnersNotifBodyArMax: "نص إشعار غير الفائزين باللغة العربية يجب أن يكون 250 حرف أو أقل",
      rewardInfoEnMax: "معلومات المكافأة يجب أن تكون 5000 حرف أو أقل",
      rewardInfoArMax: "معلومات المكافأة يجب أن تكون 5000 حرف أو أقل",
      tcInfoEnMax: "الشروط والأحكام يجب أن تكون 5000 حرف أو أقل",
      tcInfoArMax: "الشروط والأحكام يجب أن تكون 5000 حرف أو أقل",
      endDateInfoEnMax: "معلومات تاريخ الانتهاء يجب أن تكون 500 حرف أو أقل",
      endDateInfoArMax: "معلومات تاريخ الانتهاء يجب أن تكون 500 حرف أو أقل",
      howToWinTitleEnMax: "عنوان طريقة الفوز يجب أن يكون 160 حرف أو أقل",
      howToWinTitleArMax: "عنوان طريقة الفوز يجب أن يكون 160 حرف أو أقل",
      howToWinInfoEnMax: "تفاصيل طريقة الفوز يجب أن تكون 5000 حرف أو أقل",
      howToWinInfoArMax: "تفاصيل طريقة الفوز يجب أن تكون 5000 حرف أو أقل",
      subTaskNameEnReq: "اسم المهمة الفرعية بالإنجليزية مطلوب",
      subTaskNameEnValid: "اسم المهمة الفرعية بالإنجليزية يجب أن يحتوي على أحرف إنجليزية فقط",
      subTaskNameEnMax: "اسم المهمة الفرعية بالإنجليزية يجب أن يكون 31 حرفًا أو أقل",
      subTaskNameArReq: "اسم المهمة الفرعية بالعربية مطلوب",
      subTaskNameArValid: "اسم المهمة الفرعية بالعربية يجب أن يحتوي على أحرف عربية فقط",
      subTaskNameArMax: "اسم المهمة الفرعية بالعربية يجب أن يكون 31 حرفًا أو أقل",
      subTaskSignalTypeReq: "نوع الإشارة مطلوب",
      subTaskTargetValueReq: "القيمة المستهدفة مطلوبة",
      subTaskTargetValueTypeError: "القيمة المستهدفة يجب أن تكون رقمًا",
      subTaskTargetValuePositive: "القيمة المستهدفة يجب أن تكون رقمًا موجبًا",
      subTaskTargetValueInteger: "القيمة المستهدفة يجب أن تكون رقمًا صحيحًا",
      subTaskTargetValueMax: "القيمة المستهدفة يجب أن تكون {max} أو أقل",
      subTaskLevelReq: "المستوى مطلوب",
    },
  },

  challengeDetails: {
    challengeDetailsTitle: "تفاصيل التحدي السريع",
    editChallengeTooltip: "لا يمكن تعديل التحديات المنتهية",
    challengeInfo: "معلومات التحدي",
    liveProgress: "التقدم اللحظي",
    winnerCap: "حد الفائزين",
    published: "تم النشر",
    unpublished: "غير منشور",
    endsIn: "ينتهي خلال {days} يوم",
    endsToday: "ينتهي اليوم",
    ended: "منتهى",
    starts: "يبدأ",
    ends: "ينتهي",
    typeLabel: "النوع",
    audience: "الفئة المستهدفة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    daysLeft: "متبقٍ {days} يوم",
    dayLeft: "متبقٍ يوم واحد",
    winnersTowardCap: "الفائزون مقابل الحد",
    ofCap: "من {cap} حد",
    personas: {
      fo: "مالك أسطول",
      so: "مالك فردي",
      driver: "سائق",
    },
    descriptionEn: "الوصف بالإنجليزية",
    descriptionAr: "الوصف بالعربية",
    howToWinEn: "كيفية الفوز بالإنجليزية",
    howToWinAr: "كيفية الفوز بالعربية",
    ctaEn: "نص الزر بالإنجليزية",
    ctaAr: "نص الزر بالعربية",
    reward: "المكافأة",
    rewardChannel: "قناة المكافأة",
    rewardImage: "صورة المكافأة",
    subTasks: "المهام الفرعية",
    subTaskTarget: "الهدف",
    subTaskUserType: "نوع المستخدم",
    subTaskType: "النوع",
    subTaskCountOne: "مهمة واحدة",
    subTaskCountMany: "{count} مهام",
    titleEn: "العنوان بالإنجليزية",
    titleAr: "العنوان بالعربية",
    bodyEn: "النص بالإنجليزية",
    bodyAr: "النص بالعربية",
    duringPromo: "خلال مدة التحدي",
    signalTypes: {
      kyc: "التحقق",
      referral: "إحالة",
      add_vehicle: "إضافة مركبة",
      add_driver: "إضافة سائق",
      add_maintenance: "إضافة مصروف",
      covered_km: "المسافة المقطوعة",
      join_fleet: "الانضمام لأسطول",
      level: "المستوى",
    },
    notifications: "الإشعارات",
    na: "—",
    rewardTypes: {
      air_recharge: "شحن رصيد",
    },
    notificationTypes: {
      start_quick_challenge: "النشر",
      mid_quick_challenge: "تذكير منتصف المدة",
      last_day_quick_challenge: "تذكير اليوم الأخير",
      winner: "الفائزون",
      non_winner: "غير الفائزين",
    },
    participants: "المشاركون",
    completions: "الإتمامات",
    winners: "الفائزون",
    usersTab: "المستخدمون",
    rewardsTab: "المكافآت",
    auditTab: "مراجعة الفائزين",
    noUsers: "لم يكمل أي مستخدم هذا التحدي بعد",
    noRewards: "لم يتم تقديم أي مكافآت بعد",
  },

  usersAnalytics: {
    totalWinners: "إجمالي الفائزين",
    totalCompleted: "إجمالي المكتملين",
    totalNonWinners: "إجمالي غير الفائزين",
    totalParticipants: "إجمالي المشاركين",
    deletedWinners: "الفائزون المحذوفون",
  },

  rewardsAnalytics: {
    totalEarned: "إجمالي المكتسبات",
    totalRedeemed: "إجمالي المستردة",
    pendingSelection: "في انتظار الاختيار",
    selected: "تم الاختيار",
    expiredNotSelected: "منتهية — لم تُختَر",
    expiredNotRedeemed: "منتهية — لم تُسترَد",
  },

  winnerAudit: {
    title: "مراجعة الفائزين",
    qualifiedUsers: "المستخدمون المؤهلون",
    fraudFilter: "إظهار المشبوهين فقط",
    submitRewards: "إرسال المكافآت",
    submitConfirm:
      "سيتم صرف مكافآت فوري إير ريتشارج عبر فوري لجميع المستخدمين المحددين. لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد؟",
    deselect: "إلغاء التحديد",
    rank: "الترتيب",
  },

  participantsList: {
    sectionTitle: "المشاركون في التحدي",
    searchPlaceholder: "ابحث بالاسم أو رقم الهاتف",
    personaLabel: "الفئة",
    allPersonas: "كل الفئات",
    completionDateLabel: "تاريخ الإتمام",
    noResults: "لا يوجد مشاركون مطابقون للفلاتر",
    columns: {
      rank: "الترتيب",
      displayName: "الاسم",
      persona: "الفئة",
      phoneNumber: "رقم الهاتف",
      completedAt: "وقت الإتمام",
      fraudFlag: "إشارة احتيال",
      status: "الحالة",
    },
    selectedCount: "{selected} من {total} تم تحديدهم",
    submitSelection: "إرسال التحديد",
    submitSelectionConfirm:
      "سيؤدي هذا إلى اعتماد الفائزين المحددين لتخصيص المكافآت. هل أنت متأكد؟",
    submitSelectionSuccess: "تم إرسال التحديد بنجاح",
    outOfCapTooltip: "أعلى من الحد الأقصى للفائزين - غير قابل للتحديد",
    notQualifiedTooltip: "غير مؤهل للحصول على مكافأة - غير قابل للتحديد",
    deletedUserTooltip: "لا يمكن تحديد المستخدمين المحذوفين",
  },

  rewardsList: {
    sectionTitle: "مكافآت التحدي",
    searchPlaceholder: "بحث بالاسم أو رقم الهاتف",
    personaLabel: "الفئة",
    allPersonas: "كل الفئات",
    statusLabel: "حالة المكافأة",
    allStatuses: "كل الحالات",
    noResults: "لا توجد مكافآت مطابقة للفلاتر",
    columns: {
      displayName: "الاسم",
      persona: "الفئة",
      phoneNumber: "رقم الهاتف",
      rewardAmount: "قيمة المكافأة",
      status: "حالة المكافأة",
      selectionExpiresAt: "انتهاء الاختيار",
      redemptionExpiresAt: "انتهاء الاسترداد",
    },
    status: {
      earned: "مكتسبة",
      selected: "تم الاختيار",
      redeeming: "جارٍ الاسترداد",
      redeemed: "تم الاسترداد",
      selection_expired: "انتهى الاختيار",
      redemption_expired: "انتهى الاسترداد",
    },
    analytics: {
      totalEarned: "إجمالي المكتسب",
      pendingSelection: "بانتظار الاختيار",
      selected: "تم الاختيار",
      totalRedeemed: "إجمالي المسترد",
      expiredNotSelected: "منتهية (بدون اختيار)",
      expiredNotRedeemed: "منتهية (بدون استرداد)",
    },
  },
};
